<template>
  <div>
    <a-tabs type="card">
      <a-tab-pane key="1" tab="模板管理">
        <Template />
      </a-tab-pane>
      <a-tab-pane key="2" tab="字段管理">
        <Filed />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
import Filed from './components/Filed/index'
import Template from './components/Template/index'

export default {
  components: {
    Template,
    Filed
  }
}
</script>
